var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2560"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6797 3H20.2266L13.6753 10.6233L20.7891 21H15.5508L10.7615 14.0139L4.75781 21H3.21094L10.0751 13.0126L3.21094 3H8.44922L12.9889 9.622L18.6797 3ZM16.3264 19.875H18.4709L12.8149 11.6245L11.6219 13.0126L16.3264 19.875ZM10.9355 12.0114L5.52905 4.125H7.67358L12.1284 10.6233L10.9355 12.0114Z",
    fill: "#070A26"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.ba9ed3f890427962cbc5bee4003670b0.svg";
export { ForwardRef as ReactComponent };